import { render, staticRenderFns } from "./PostHeader.vue?vue&type=template&id=097383a1&scoped=true&"
import script from "./PostHeader.vue?vue&type=script&lang=ts&"
export * from "./PostHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PostHeader.vue?vue&type=style&index=0&id=097383a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097383a1",
  null
  
)

export default component.exports